// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"TestimonialOne_testimonial__pGmjV","thumb":"TestimonialOne_thumb__3IO7K","clientInfo":"TestimonialOne_clientInfo__3i9-0"};